export default __webpack_public_path__ + "static/MarkusGundmundsson-e0d5c712a24fb342e528254dd8b2cd60.jpg";